"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectScreen = SelectScreen;
const React = __importStar(require("react"));
const FluidMaxPerformanceResult = __importStar(require("./coil-pro-results/fluid-max-performance-results"));
const FluidTargetTemperatureResult = __importStar(require("./coil-pro-results/fluid-target-temperature-results"));
const DxMaxPerformanceResult = __importStar(require("./coil-pro-results/dx-max-performance-results"));
const DxTargetTemperatureResult = __importStar(require("./coil-pro-results/dx-target-temperature-results"));
const SteamMaxPerformanceResult = __importStar(require("./coil-pro-results/steam-max-performance-results"));
const SteamTargetTemperatureResult = __importStar(require("./coil-pro-results/steam-target-temperature-results"));
const CondensorMaxPerformanceResult = __importStar(require("./coil-pro-results/condensor-max-performance-results"));
const CondensorTargetTemperatureResult = __importStar(require("./coil-pro-results/condensor-target-temperature-results"));
const InputParser = __importStar(require("./input-parser"));
function SelectScreen(props) {
    switch (props.resultScreen) {
        case "FluidMaxPerformanceResult":
            return createFluidMaxPerformanceResultScreen(props.pvses);
        case "FluidTargetTemperatureResult":
            return createFluidTargetTemperatureResultScreen(props.pvses);
        case "DxMaxPerformanceResult":
            return createDxMaxPerformanceResultScreen(props.pvses);
        case "DxTargetTemperatureResult":
            return createDxTargetTemperatureResultScreen(props.pvses);
        case "SteamMaxPerformanceResult":
            return createSteamMaxPerformanceResultScreen(props.pvses);
        case "SteamTargetTemperatureResult":
            return createSteamTargetTemperatureResultScreen(props.pvses);
        case "CondensorMaxPerformanceResult":
            return createCondensorMaxPerformanceResultScreen(props.pvses);
        case "CondensorTargetTemperatureResult":
            return createCondensorTargetTemperatureResultScreen(props.pvses);
        case "ExpressCalcPressureSteamMaxPerformanceResult":
            return createExpressCalcPressureSteamMaxPerformanceResultScreen(props.pvses[0]);
        case "ExpressCalcTemperatureSteamMaxPerformanceResult":
            return createExpressCalcTemperatureSteamMaxPerformanceResultScreen(props.pvses[0]);
        case "ExpressCalcHumiditySteamMaxPerformanceResult":
            return createExpressCalcHumiditySteamMaxPerformanceResultScreen(props.pvses[0]);
        case "ExpressCalcPressureSteamTargetTemperatureResult":
            return createExpressCalcPressureSteamTargetTemperatureResultScreen(props.pvses[0]);
        case "ExpressCalcTemperatureSteamTargetTemperatureResult":
            return createExpressCalcTemperatureSteamTargetTemperatureResultScreen(props.pvses[0]);
        case "ExpressCalcHumiditySteamTargetTemperatureResult":
            return createExpressCalcHumiditySteamTargetTemperatureResultScreen(props.pvses[0]);
        case "ExpressCalcTemperatureOutFluidMaxPerformanceResult":
            return createExpressCalcFluidMaxPerformanceResultScreen(props.pvses[0], "temperature");
        case "ExpressCalcFlowFluidMaxPerformanceResult":
            return createExpressCalcFluidMaxPerformanceResultScreen(props.pvses[0], "flow");
        case "ExpressCalcTemperatureOutFluidTargetTemperatureResult":
            return createExpressCalcFluidTargetTemperatureResultScreen(props.pvses[0], "temperature");
        case "ExpressCalcFlowFluidTargetTemperatureResult":
            return createExpressCalcFluidTargetTemperatureResultScreen(props.pvses[0], "flow");
        case undefined:
        default:
            return React.createElement("div", null);
    }
}
function createDxMaxPerformanceResultScreen(pvses) {
    const inputs = pvses.map(pvs => InputParser.parseFreonMaxPerformanceInput(pvs));
    return React.createElement(DxMaxPerformanceResult.CoilProResultContainer, { inputs: inputs });
}
function createCondensorMaxPerformanceResultScreen(pvses) {
    const inputs = pvses.map(InputParser.parseFreonMaxPerformanceInput);
    return (React.createElement(CondensorMaxPerformanceResult.CoilProResultContainer, { inputs: inputs }));
}
function createDxTargetTemperatureResultScreen(pvses) {
    const inputs = pvses.map(InputParser.parseFreonTargetTemperatureInput);
    return React.createElement(DxTargetTemperatureResult.CoilProResultContainer, { inputs: inputs });
}
function createCondensorTargetTemperatureResultScreen(pvses) {
    const inputs = pvses.map(InputParser.parseFreonTargetTemperatureInput);
    return (React.createElement(CondensorTargetTemperatureResult.CoilProResultContainer, { inputs: inputs }));
}
function createFluidMaxPerformanceResultScreen(pvses) {
    const inputs = pvses.map(InputParser.parseFluidMaxPerformanceInput);
    return React.createElement(FluidMaxPerformanceResult.CoilProResultContainer, { inputs: inputs });
}
function createFluidTargetTemperatureResultScreen(pvses) {
    const inputs = pvses.map(InputParser.parseFluidTargetTemperatureInput);
    return (React.createElement(FluidTargetTemperatureResult.CoilProResultContainer, { inputs: inputs }));
}
function createSteamMaxPerformanceResultScreen(pvses) {
    const inputs = pvses.map(pvs => InputParser.parseSteamMaxPerformanceInput(pvs));
    return React.createElement(SteamMaxPerformanceResult.CoilProResultContainer, { inputs: inputs });
}
function createSteamTargetTemperatureResultScreen(pvses) {
    const inputs = pvses.map(pvs => InputParser.parseSteamTargetTemperatureInput(pvs));
    return (React.createElement(SteamTargetTemperatureResult.CoilProResultContainer, { inputs: inputs }));
}
function createExpressCalcPressureSteamMaxPerformanceResultScreen(pvs) {
    const inputs = InputParser.parseExpressCalcPressureSteamMaxPerformanceInputs(pvs);
    return React.createElement(SteamMaxPerformanceResult.CoilProResultContainer, { inputs: inputs });
}
function createExpressCalcTemperatureSteamMaxPerformanceResultScreen(pvs) {
    const inputs = InputParser.parseExpressCalcTemperatureSteamMaxPerformanceInputs(pvs);
    return React.createElement(SteamMaxPerformanceResult.CoilProResultContainer, { inputs: inputs });
}
function createExpressCalcHumiditySteamMaxPerformanceResultScreen(pvs) {
    const inputs = InputParser.parseExpressCalcHumiditySteamMaxPerformanceInputs(pvs);
    return React.createElement(SteamMaxPerformanceResult.CoilProResultContainer, { inputs: inputs });
}
function createExpressCalcPressureSteamTargetTemperatureResultScreen(pvs) {
    const inputs = InputParser.parseExpressCalcPressureSteamTargetTemperatureInput(pvs);
    return (React.createElement(SteamTargetTemperatureResult.CoilProResultContainer, { inputs: inputs }));
}
function createExpressCalcTemperatureSteamTargetTemperatureResultScreen(pvs) {
    const inputs = InputParser.parseExpressCalcTemperatureSteamTargetTemperatureInput(pvs);
    return (React.createElement(SteamTargetTemperatureResult.CoilProResultContainer, { inputs: inputs }));
}
function createExpressCalcHumiditySteamTargetTemperatureResultScreen(pvs) {
    const inputs = InputParser.parseExpressCalcHumiditySteamTargetTemperatureInput(pvs);
    return (React.createElement(SteamTargetTemperatureResult.CoilProResultContainer, { inputs: inputs }));
}
function createExpressCalcFluidMaxPerformanceResultScreen(pvs, stepProperty) {
    const inputs = InputParser.parseExpressCalcFluidMaxPerformanceInputs(pvs, stepProperty);
    return React.createElement(FluidMaxPerformanceResult.CoilProResultContainer, { inputs: inputs });
}
function createExpressCalcFluidTargetTemperatureResultScreen(pvs, stepProperty) {
    const inputs = InputParser.parseExpressCalcFluidTargetTemperatureInput(pvs, stepProperty);
    return (React.createElement(FluidTargetTemperatureResult.CoilProResultContainer, { inputs: inputs }));
}
//# sourceMappingURL=result-screen-selector.js.map